<template>
  <van-popup
    v-model:show="showPopup"
    position="bottom"
    closeable
    :style="{ height: height }"
    @close="clickCloseIcon"
    :round="round"
  >
    <div class="flex flex-col h-full">
      <PopupTitle :title="props.title" />
      <div class="flex-1 overflow-hidden overflow-y-auto content" :class="hasButton ? 'pb-88' : ''">
        <slot></slot>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { useVModel } from "@vueuse/core";
import PopupTitle from "./PopupTitle.vue";

const props = defineProps({
  show: { default: false },
  title: { default: "" },
  hasButton: { default: false },
  height: { default: "100%" },
  round: { default: false }
});

const emit = defineEmits(["update:show", "changeVisible"]);

const showPopup = useVModel(props, "show", emit);

const clickCloseIcon = () => emit("update:show", false);
</script>
